'use strict';

const Mn = require('backbone.marionette');
const Template = require('balus/ui/template/body/process/content/relation.hbs');

module.exports = Mn.View.extend({
    template: Template,
    serializeData: function() {
        return {
            name: this.model.getWork().getName(),
            input: this.model.isInput(),
            output: this.model.isOutput()
        }
    },
    getRelation: function() {
        return {
            input: this.$('.input input').is(':checked'),
            output: this.$('.output input').is(':checked'),
        }
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/process/content/relation.js